<template>
  <ScNavigationItem
    :key="item.id"
    :title="item.fields.title"
    :link="item.fields.link"
    class="menu-item-mobile"
    @clicked:title="handleClick(item.id)"
  />
</template>

<script>
import ScNavigationItem from '../../sc-navigation-item'

export default {
  components: {
    ScNavigationItem
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleClick (id) {
      this.$emit('clicked:item', id)
    }
  }
}
</script>

<style lang="scss" scoped>

.menu-item-mobile {
  display: inline-block;
  width: 100%;

  &.inverted ::v-deep  > .link {
    color: $color-black;
  }
}
</style>
